<ion-icon *ngIf="isIonIcon(tabIcon)" class="icon" [name]="tabIcon"></ion-icon>
<i *ngIf="!isIonIcon(tabIcon)" class="icon app-{{ tabIcon }}"></i>

<span class="label">{{ tabLabel | translate }}</span>
<span class="badge" *ngIf="tabNotificationAdvice > 0">{{ tabNotificationAdvice }}</span>
